import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';

export const getNutrientDv = async (shareToken) => {
  const apiURL = API_HOST + '/diets/nutrient_dv_list?share_token=' + shareToken;
  const { token, userID } = useCurrentUser();
  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
